import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useConfig } from '../../config';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { navigateToSitecorePage, skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.PersonskadeUlykke,
        tekst: 'Ulykkesskade',
    },
    {
        id: KategoriSvarId.PersonskadeAnnet,
        tekst: 'Annet',
    },
];

export const DegOgDineUlykkesskadeEllerAnnet = () => {
    const { url } = useConfig().links.degogdinelandingsside;
    const navigate = useNavigate();

    const onNext = (svarId: KategoriSvarId) => {
        if (svarId === KategoriSvarId.PersonskadeUlykke) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.PersonskadeUlykke));
        } else if (svarId === KategoriSvarId.PersonskadeAnnet) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.PersonskadeAnnet));
        }
    };

    return (
        <GruppeLandingsside
            title="Personskade"
            onNext={onNext}
            navigateToParent={() => navigateToSitecorePage(url)}
            alternativer={alternativer}
            kategoriId="personskade"
        />
    );
};
